<script>
  import { onMount } from "svelte";
  import {
    API_DIR,
    SESSION_LS,
    currentPage,
    selectedConfigFile,
    selectedPage,
    showLoadingModal,
    uniqueAppIdValuesList,
    uniqueFirmwareValuesList
  } from "../store";
  import Select from "svelte-select/Select.svelte";
  import { CONFIG_CATALOG } from "../config_code_catalog";

  console.log($selectedConfigFile);

  let filenameInput;
  let configGropuInput;
  let descriptionInput = $selectedConfigFile.comment;
  let appIdInput = $selectedConfigFile.app_id;
  //console.log( JSON.parse( $selectedConfigFile.compatible_firmware) );
  let firmwareSelection = $selectedConfigFile.compatible_firmware;
  let versionInput = $selectedConfigFile.version;

  let configType = $selectedConfigFile.type;
  let configTypes = ["LMU", "JPOD", "JPOD2"];

  async function saveConfigChanges() {
    const requestBody = JSON.stringify({
      allow_overwrite: true,
      filename: $selectedConfigFile.filename,
      json_data: $selectedConfigFile.data,
      compatible_firmware: firmwareSelection,
      device_updates: true,
      comment: descriptionInput,
      app_id: appIdInput,
      version: versionInput,
      type: configType,
      company: $selectedConfigFile.company || [],
    });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Content-Length": requestBody.length.toString(),
        "Session-Id": localStorage.getItem($SESSION_LS)
      },
      body: requestBody
    };

    try {
      showLoadingModal.set(true);

      const response = await fetch(
        `${$API_DIR}/api/v1/save-config-file`,
        requestOptions
      );
      showLoadingModal.set(false);

      if (response.ok) {
        alert("Archivo actualizado de manera correcta");
        selectedPage.set(4);
      } else if (response.status === 409) {
        alert("El archivo ya existe en el destino especificado.");
      } else if (response.status === 410) {
        alert(
          "Ya existe un archivo con las mismas características. No se puede subir el archivo."
        );
      } else if (response.status === 401) {
        location.reload();
      } else {
        alert("Error en la actualización");
      }
    } catch (error) {
      alert("Error en la solicitud al servidor:" + error);
    }
  }

  function handleFirmwareSelection(e) {
    try {
      firmwareSelection = e.detail.map((obj) => obj.value);
    } catch (error) {
      firmwareSelection = [];
      //console.log(error);
    }
  }
  function handleAppIdSelection(e) {
    try {
      appIdInput = e.detail.map((obj) => obj.value);
    } catch (error) {
      appIdInput = [];
      //console.log(error);
    }
  }

  onMount(async () => {
    //getJsonFromCsv("1.4-TTU730_TEST");
  });
</script>

<hr />

<div class="row">
  <div class="col-lg-6">
    <h2>Edit Config File</h2>
  </div>

  <div class="col-lg-6">
    <div class="d-flex justify-content-end">
      <h2>{$selectedConfigFile.filename}</h2>
    </div>
  </div>
</div>

<hr />

<div class="row">
  <div class="col-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Name</span>
      <input
        disabled
        type="text"
        class="form-control"
        placeholder="File Name"
        aria-describedby="basic-addon1"
        value={$selectedConfigFile.filename}
      />
    </div>

    <!--<div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">New Config Group</span>
      <input
        type="text"
        class="form-control"
        placeholder="Group Name"
        aria-describedby="basic-addon1"
        value={$selectedConfigFile.compatible_firmware}
      />
    </div>-->
  </div>

  <div class="col-6">
    <div class="input-group mb-3">
      <span class="input-group-text">Version</span>
      <input
        disabled
        id="versionInput"
        class="form-control"
        placeholder="Config File Version"
        value={versionInput}
      />
    </div>
  </div>

  <div class="col-6">
    <div class="input-group mb-3 row" style="margin-left: inherit;">
      <span class="input-group-text col" style="max-width: fit-content;"
        >App IDs</span
      >
      <Select
        class="col"
        items={$uniqueAppIdValuesList}
        value={appIdInput}
        placeholder="Selecciona una o más opciones"
        selected={$uniqueAppIdValuesList}
        multiple
        on:input={handleAppIdSelection}
      />
    </div>
  </div>

  <div class="col-6">
    <div class="input-group mb-3 row" style="margin-left: inherit;">
      <span class="input-group-text col" style="max-width: fit-content;"
        >Compatible FW</span
      >
      <Select
        class="col"
        items={$uniqueFirmwareValuesList}
        value={firmwareSelection}
        placeholder="Selecciona una o más opciones"
        selected={$uniqueFirmwareValuesList}
        multiple
        on:input={handleFirmwareSelection}
      />
    </div>
  </div>

  <div class="col-6">
    <div class="input-group mb-3">
      <span class="input-group-text">Type</span>

      <select
        id="typeInput"
        class="form-control"
        bind:value={configType}
      >
        {#each configTypes as option}
          <option value={option}>
            {option}
          </option>
        {/each}
      </select>

      <!--<input
        disabled
        id="typeInput"
        class="form-control"
        placeholder="Config File Type"
        value={configType}
      />-->
    </div>
  </div>

  <div class="col-6">
    <div class="input-group">
      <span class="input-group-text">Description</span>
      <textarea
        id="descriptionInput"
        class="form-control"
        placeholder="Config File Description"
        bind:value={descriptionInput}
      />
    </div>
  </div>
</div>

<br />

<div class="d-flex justify-content-end">
  <button
    type="button"
    class="btn btn-danger"
    style="margin-right: 12px;"
    on:click={() => {
      selectedPage.set(4);
    }}><i class="bi bi-x-square" /> Cancel</button
  >

  <button
    type="button"
    class="btn btn-primary"
    on:click={async () => await saveConfigChanges()}
    ><i class="bi bi-check-square-fill" /> Save Changes</button
  >
</div>

<hr />

<div class="table-responsive">
  <table
    class="table table-hover table-sm table-bordered table-striped table-responsive"
  >
    <thead>
      <tr>
        {#each Object.keys($selectedConfigFile.data[0]) as header}
          {#if header == "parameter_id" || header == "parameter_index"}
            <th scope="col">{header.toUpperCase()}</th>
          {/if}
        {/each}
        <th scope="col">LABEL</th>
      </tr>
    </thead>
    <tbody>
      {#each $selectedConfigFile.data as item}
        <tr>
          {#each Object.keys(item) as header}
            {#if header == "parameter_id" || header == "parameter_index"}
              <td>{item[header] !== undefined ? item[header] : "undefined"}</td>
            {/if}
          {/each}
          <td>
            {#if CONFIG_CATALOG[item.parameter_id] !== undefined}
              {CONFIG_CATALOG[item.parameter_id]} - {item["parameter_index"]}
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
</style>
